export default __webpack_public_path__ + "static/media/unknown-dark.5e04ea32.svg";